import { sa, sab, sum } from "./stellazhi";
import { ps_kp, psm, psp, psp_kp, pst } from "./stoli_podkatnie";
import {
    skk,
    skp_kp,
    smo,
    smp,
    snp_kp,
    som,
    sop,
    sop_kp,
    spk_kp,
    spl,
    spl_kp,
    spm,
    sr_kp,
    sur,
} from "./stoyki_podkatnie";
import { stulya } from "./stulya/stulya";
import { ksm, ostrov, raskroinii, smk, spb, verstak } from "./tables";
import { al_kp, tm, tmu } from "./telezhki";
import { tp_3, tp_4, ts_1, ts_10, ts_2, ts_3, ts_5, ts_7 } from "./tumbi";
import { vs } from "./verstaki";
import { shk, sha, shi } from "./wardrobes";

export const elementMappings = {
    // Столы
    "spb.glb": spb,
    "ostrov.glb": ostrov,
    "verstak.glb": verstak,
    "ksm.glb": ksm,
    "raskroinii.glb": raskroinii,
    "smk.glb": smk,

    // Стойки
    "stoyka__sop.glb": sop,
    "stoyka__som.glb": som,
    "stoyka__smo.glb": smo,
    "stoyka__smp.glb": smp,
    "stoyka__spm.glb": spm,
    "stoyka__spl.glb": spl,
    "stoyka__sur.glb": sur,
    "stoyka__skk.glb": skk,
    "stoyka__sop_kp.glb": sop_kp,
    "stoyka__sr_kp.glb": sr_kp,
    "stoyka__skp_kp.glb": skp_kp,
    "stoyka__spk_kp.glb": spk_kp,
    "stoyka__spl_kp.glb": spl_kp,
    "stoyka__snp_kp.glb": snp_kp,

    // Столы подкатные
    "stol__psm.glb": psm,
    "stol__psp.glb": psp,
    "stol__ps_kp.glb": ps_kp,
    "stol__psp_kp.glb": psp_kp,
    "stol__pst.glb": pst,

    // Тележки
    "telezhka__tm.glb": tm,
    "telezhka__tmu.glb": tmu,
    "telezhka__al_kp.glb": al_kp,

    // Тумбы
    "tumba__tp_3.glb": tp_3,
    "tumba__tp_4.glb": tp_4,
    "tumba__ts_1.glb": ts_1,
    "tumba__ts_2.glb": ts_2,
    "tumba__ts_3.glb": ts_3,
    "tumba__ts_5.glb": ts_5,
    "tumba__ts_7.glb": ts_7,
    "tumba__ts_10.glb": ts_10,

    // Стеллажи
    "stellazh_sab.glb": sab,
    "stellazh_sa.glb": sa,
    "stellazh_sum.glb": sum,
    "stulya.glb": stulya,
    "verstak__vs.glb": vs,

    // Шкафы
    "shkafy_shk.glb": shk,
    "shkafy_sha.glb": sha,
    "shkafy_shi.glb": shi,
};
